import LocaleStrings from "@language";

// ------------- Api4 Credential --------------/
export const MAIN_URL = "https://app.eventify.io";
export const INSTANCE_URL = "https://api4.eventify.io";
export const SITE_URL = "eventify.io";
export const PORTAL_URL = "https://{seocode}.eventify.io";

// --- Stripe --- /
// AU
export const STRIPE_PUBLISHABLE_KEY = "pk_live_VZSpPMDkLza88TRanKPF0xMU";
// UK
export const STRIPE_PUBLISHABLE_KEY_UK =
  "pk_live_51Qjk5ZKCTtcnWW4Yr2XGsY5Fz7qbfsHU1wnICiBPllmxU6U3aQf04W4Eb1JlMywVDioQAPAZZKddJim894PVhXJ8007iWAmX2s";

// --- Paypal --- /
export const PAYPAL_CLIENT_ID =
  "AaqSE213mT11w6bRVAygLzOtfEFuzOxsQceK5M7qC8YaO-MHpTVuR_rZhm_IqoHZp3aFGyxGoCAVhzKq";

// --- Razorpay --- /
export const RAZORPAY_CLIENT_ID = "rzp_live_TmRMbNLfBhcWKm";
// ------------- --------------- --------------/

export const TICKET_FOLDER = `/t2`;
export const WEB_FOLDER = `/p/#`;
export const TICKET_PORTAL_URL = `${PORTAL_URL}${TICKET_FOLDER}`;
export const WEB_PORTAL_URL = `${PORTAL_URL}${WEB_FOLDER}`;
export const PROPOSAL_PORTAL_URL = `${window.location.origin}${TICKET_FOLDER}/proposal`;
export const BASE_IMAGES_URL = `${INSTANCE_URL}/api/v2/files`;
export const CDN_BASE_IMAGES_URL = `https://cdn.eventify.io`;

export const APP_API_KEY =
  "c26f1a65cc24c851ed1d2ebb69eb2d64686823891ca0408dae59fb58b6844293";
export const REVIEWER_API_KEY =
  "f02c4d32687e70fae1ae4b2eb71533c6331ccbf3d592441199700f5e0770e515";

export const LOCAL_STRIPE = false;
export const LOCAL_STRIPE_URL = `http://localhost:3000${TICKET_FOLDER}`;
export const EVENTIFY_FEE = 1.0;
export const STRIPE_FEE = 2.9;
export const STRIPE_FEE_EXTRA = 0.3;

export const LABEL_POSITION_TOP = "TOP";
export const LABEL_POSITION_LEFT = "LEFT";
export const DEFAULT_INTEREST_TAG_NAME = "[Unspecified]";
export const NO_TRACK = "##NOTRACK##";
export const COMMON_REDIRECT_URI = "https://link.eventify.io/share/index.php";

export const FACEBOOK_APP_ID = "619283028614780";
export const FACEBOOK_CLIENT_ID = "b607b2814292325f220dc1e916c0033f";

export const LINKEDIN_CLIENT_ID = "866j4e0un8w5n4";
export const LINKEDIN_SECRET_KEY = "WPL_AP1.3zSzCxQabaAGT2tq.mkoQeQ==";

export const X_CLIENT_ID = "T1ppM0xVcTN6Mlh2cFlvcXUweDQ6MTpjaQ";
export const X_SECRET_KEY =
  "HZC3_xxvVyFeuNsrVoh4dljcNlPmFFo1x0k02NEhIZhPOtP1ob";

export const INITIAL_APP_LANG = "en";

export const STATIC_FAV_ICON =
  "https://uploads-ssl.webflow.com/61cee5eb4d566d3471eca114/6225b2994858c92ff025b7b4_Eventify%20Favicon.png";

export const LOCAL_STORAGE_ACCESS_KEYS = {
  state: "state",
  reviewer: "reviewer",
};

export const ALLOWED_LAYOUTS = {
  admin: "admin",
  auth: "auth",
  reviewer: "reviewer",
};

export const COMMON_MODAL_PAYLOAD = {
  state: false,
  size: "lg", // sm(popup), lg(large modal), screen(occupies full screen),
  data: null,
};

export const COMPANY_PREFIX = "__company_details__";
export const FIXED_COMPANY_FIELD = [
  {
    key: "section",
    defaultfields: true,
    isactive: true,
    name: "companydetails",
    id: "companydetails",
    label: LocaleStrings.kCompanyDetailstext,
    description: LocaleStrings.kCompanyDetailsSubtitleText,
    header: "Section",
  },
];
